<template lang="html">
<div class="tabNavs" ref="tabNavs">
    <div v-for="(item,index) in navs" :key="index" @click="tabChange($event,index)" :class="['tabItem',{'act':navAct===index}]">
        {{item}}
    </div>
    <div class="moveLine" :style="lineStr"></div>
</div>
</template>

<script>
export default {
    name: 'tabNavs',
    model: {
        prop: "act", // 父组件设置v-model的变量值，v-model="message"
        event: "onchange" // 父组件监听message事件
    },
    props: ['navs', 'act'],
    data() {
        return {
            navAct: 0,
            navX: 15,
        }
    },
    computed: {
        lineStr: function () {
            var str = 'width:60px;';
            str = str + "left:" + this.navX + "px;";
            return str;
        },

    },

    methods: {
        navx(act) {
            var ret = 15;
            if (act > 0) {
                ret = act * 105 + 15;
            }
            return ret;
        },
        setNavAct(navAct) {
            this.navAct = navAct;
            this.navX = this.navx(navAct);
            this.$emit('onchange', navAct);
        },
        tabChange: function (e, inx) {
            console.log(e);
            this.navAct = inx;
            this.$emit('onchange', inx);
            this.navX = e.target.offsetLeft;

        },
    }
}
</script>

<style lang="scss" scoped>
.tabNavs {
    height: 50px;
    padding-left: 15px;
    background: white;
    position: relative;

    .tabItem {
        float: left;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        margin-right: 45px;
        cursor: pointer;
    }

    .tabItem.act {
        color: rgb(86, 119, 252);
    }

    .moveLine {
        height: 2px;
        background: rgb(86, 119, 252);
        position: absolute;
        bottom: 0px;

        transition-property: all;
        transition-duration: 0.2s;
    }
}
</style>
<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// tabNavs.vue?9e7e19b6